import request from '../utils/request.js'

//商品详情
export function getGoodDetail(gid) {
  let newGid = "";
  if(gid.indexOf("?") > 0){
    let gidArr = gid.split("?");
    newGid = gidArr[0];
  }else{
    newGid = gid;
  }

  return request({
    url: process.env.PRODUCTURL + '/h5/detail/' + newGid,
    method: 'get',
  })
}

//获取购物车数量
export function viewCartShop() {
  return request({
    url: process.env.API + "/cart/goods/count?v="+new Date().getTime(),
     // url: "https://trade.reflower.com.cn/cart/goods/count/cart/goods/count?v="+new Date().getTime(),
    method: 'get',
  })
}


//获取公众号弹窗配置
export function getNotifyByPageType() {
  return request({
    url: process.env.I_URL + "/api/goods/getNotifyByPageType",
    // url: "/goods/getNotifyByPageType",
    method: 'get',
  })
}


//猜你喜欢
export function getRecommendGoodsList() {
  return request({
    url: process.env.I_URL + "/api/goods/recommendGoods",
    method: 'get',
  })
}


//加入购物车
export function addCart(data) {
  return request({
    url:  process.env.API + "/cart/add",
    // url:  "/cart/add",
    method: 'post',
    data:data
  })
}


//立即预约
export function discountAppointment(pid,gid) {
  return request({
    url:  process.env.I_URL + "/api/goods/discountAppointment?pid=" + pid + "&gid=" + gid,
    // url:  "/goods/discountAppointment?pid=" + pid + "&gid=" + gid,
    method: 'post',
    header: {
      'content-type': 'application/json', // 默认值
    },

  })
}

//查询已预约人数
export function getAppointmentNum(gid) {
  return request({
    url:  process.env.I_URL + "/api/goods/getAppointmentNum?gid=" + gid,
    // url:  "/goods/getAppointmentNum?gid=" + gid,
    method: 'post',
    header: {
      'content-type': 'application/json', // 默认值
    },
  })
}

//查询预约状态
export function validateDiscountPromotion(pid,gid) {
  return request({
    url:  process.env.I_URL + "/api/goods/validateDiscountPromotion?pid=" + pid + "&gid=" + gid,
    // url:  "/goods/validateDiscountPromotion?pid=" + pid,
    method: 'post',
    header: {
      'content-type': 'application/json', // 默认值
    },
  })
}

//查询用户是否是新用户
export function checkIsNew(pid) {
  return request({
    url:  process.env.I_URL + "/api/goods/checkIsNew",
    // url:  "/goods/checkIsNew",
    method: 'post',
    header: {
      'content-type': 'application/json', // 默认值
    },
  })
}


//获取参团列表
export function getGroupList(parameter) {
  return request({
    url:  process.env.I_URL + "/api/goods/groupBuyingList" + parameter,
    // url:  "/goods/groupBuyingList" + parameter,
    method: 'post',
    header: {
      'content-type': 'application/json', // 默认值
    },
  })
}


//购买次数已达上限
export function validateUserLimit(gbpId) {
  return request({
    url:  process.env.I_URL + "/api/goods/validateUserLimit?gbpId=" + gbpId,
    // url:  "/goods/validateUserLimit?gbpId=" + gbpId,
    method: 'post',
    header: {
      'content-type': 'application/json', // 默认值
    },
  })
}

//获取分享公众号信息
export function wechatShare(data) {
  return request({
    url:  process.env.SALEURL + "/wechatShare",
    // url:  "/coupon/wechatShare",
    method: 'post',
    data:data,
    header: {
      'content-type': 'application/json', // 默认值
    },
  })
}



//请求结算页
export function orderNewOrder(data) {
  return request({
    url:  process.env.API + "/order/newOrder",
    method: 'post',
    header: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:data
  })
}
//获取商品评论
export function rateList(data) {
  return request({
    url: process.env.API + "/data/order/fcomment",
    method: 'get',
    params: data
  })
}


//查询用户下单必要信息接口
export function newOrderPre(data) {
  return request({
    url: process.env.NODE_ENV == 'development'? "/rest/neworder/pre" :  process.env.API + "/rest/neworder/pre",
    method: 'post',
    data:data
  })
}

//鲜花超市商品的下单接口
export function newOrderSave(data) {
  return request({
    url: process.env.NODE_ENV == 'development'? "/rest/neworder/save" :  process.env.API + "/rest/neworder/save",
    method: 'post',
    data:data
  })
}









// import request from '../utils/request.js'

// //商品详情
// export function getGoodDetail(gid) {
//   return request({
//     url: process.env.PRODUCTURL + '/h5/detail/' + gid,
//     method: 'get',
//   })
// }

// //获取购物车数量
// export function viewCartShop() {
//   return request({
//     // url: process.env.API + "/cart/goods/count?v="+new Date().getTime(),
//      url: "/cart/goods/count?v="+new Date().getTime(),
//     method: 'get',
//   })
// }


// //获取公众号弹窗配置
// export function getNotifyByPageType() {
//   return request({
//     // url: process.env.I_URL + "/api/goods/getNotifyByPageType",
//     url: "/goods/getNotifyByPageType",
//     method: 'get',
//   })
// }


// //猜你喜欢
// export function getRecommendGoodsList() {
//   return request({
//     url: process.env.I_URL + "/api/goods/recommendGoods",
//     method: 'get',
//   })
// }


// //加入购物车
// export function addCart(data) {
//   return request({
//     // url:  process.env.API + "/cart/add",
//     url:  "/cart/add",
//     method: 'post',
//     data:data
//   })
// }


// //立即预约
// export function discountAppointment(pid,gid) {
//   return request({
//     // url:  process.env.I_URL + "/api/goods/discountAppointment?pid=" + pid + "&gid=" + gid,
//     url:  "/goods/discountAppointment?pid=" + pid + "&gid=" + gid,
//     method: 'post',
//     header: {
//       'content-type': 'application/json', // 默认值
//     },

//   })
// }

// //查询已预约人数
// export function getAppointmentNum(gid) {
//   return request({
//     // url:  process.env.I_URL + "/api/goods/getAppointmentNum?gid=" + gid,
//     url:  "/goods/getAppointmentNum?gid=" + gid,
//     method: 'post',
//     header: {
//       'content-type': 'application/json', // 默认值
//     },
//   })
// }

// //查询预约状态
// export function validateDiscountPromotion(pid,gid) {
//   return request({
//     // url:  process.env.I_URL + "/api/goods/validateDiscountPromotion?pid=" + pid,
//     url:  "/goods/validateDiscountPromotion?pid=" + pid + "&gid=" + gid,
//     method: 'post',
//     header: {
//       'content-type': 'application/json', // 默认值
//     },
//   })
// }

// //查询用户是否是新用户
// export function checkIsNew(pid) {
//   return request({
//     // url:  process.env.I_URL + "/api/goods/checkIsNew",
//     url:  "/goods/checkIsNew",
//     method: 'post',
//     header: {
//       'content-type': 'application/json', // 默认值
//     },
//   })
// }


// //获取参团列表
// export function getGroupList(parameter) {
//   return request({
//     // url:  process.env.I_URL + "/api/goods/groupBuyingList" + parameter,
//     url:  "/goods/groupBuyingList" + parameter,
//     method: 'post',
//     header: {
//       'content-type': 'application/json', // 默认值
//     },
//   })
// }


// //购买次数已达上限
// export function validateUserLimit(gbpId) {
//   return request({
//     // url:  process.env.I_URL + "/api/goods/validateUserLimit?gbpId=" + gbpId,
//     url:  "/goods/validateUserLimit?gbpId=" + gbpId,
//     method: 'post',
//     header: {
//       'content-type': 'application/json', // 默认值
//     },
//   })
// }

// //获取分享公众号信息
// export function wechatShare(data) {
//   return request({
//     // url:  process.env.SALEURL + "/wechatShare",
//     url:  "/coupon/wechatShare",
//     method: 'post',
//     data:data,
//     header: {
//       'content-type': 'application/json', // 默认值
//     },
//   })
// }



// WEBPACK FOOTER //
// ./src/api/goodDetails.js